import styled from 'styled-components'

import { Typography } from 'components/Typography/Typography'

import { IconInfo } from 'components/Icons/InfoIcon'
import { useIsMobile } from 'utils/useIsMobile'

const WhatIsSingleAsset = styled(Typography)`
  cursor: pointer;
  & > div {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  & > div > svg {
    margin-right: 8px;
  }

  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    font-size: ${p => p.theme.typography.size.Caption1}px;
  }

  @media screen and (min-width: ${p => p.theme.breakpoints.md}px) {
    display: flex;
    align-items: center;
  }
`

const Container = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 32px;
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    position: absolute;
    top: -36px;
  }
`
interface Props {
  isDontShowSelected: boolean
  onResetDontShowThisAgain: () => void
}

export const WhatIsSLPVault = ({ isDontShowSelected, onResetDontShowThisAgain }: Props) => {
  const isMobile = useIsMobile()

  if (!isDontShowSelected) {
    return null
  }
  return (
    <Container>
      {isDontShowSelected && (
        <div style={isMobile ? { marginTop: 8 } : { marginLeft: 'auto' }}>
          <WhatIsSingleAsset variant="label1" fontWeight="light">
            <div onClick={onResetDontShowThisAgain}>
              <IconInfo />
              What are LP Vaults
            </div>
          </WhatIsSingleAsset>
        </div>
      )}
    </Container>
  )
}
